export const API_URL = process.env.REACT_APP_API_URL;
export const PAYMENT_API = process.env.REACT_APP_STRIPE_PAYMENT_ENDPOINT;
export const LOCAL_PATH = process.env.REACT_APP_WEB_APP_LOCAL_PATH;